<script setup lang="ts">
import type { Coin } from "@/lib/interfaces/calculator";
import type { FuseResult } from "fuse.js";
import { computed } from "vue";
import { UseImage } from "@vueuse/components";

interface Props {
  coin: FuseResult<Coin>;
}

const props = defineProps<Props>();
const selectedCoins = defineModel<string[]>("selectedCoins", {
  required: true,
});

const isSelected = computed(() => selectedCoins.value.includes(props.coin.item.value));

function removeItem<T>(arr: Array<T>, value: T): Array<T> {
  const index = arr.indexOf(value);
  if (index > -1) {
    arr.splice(index, 1);
  }
  return arr;
}
</script>

<template>
  <div
    class="rounded-3 overflow-hidden relative flex justify-between px-3 py-2 cursor-pointer group"
    @click.stop="
      isSelected
        ? removeItem(selectedCoins, coin.item.value)
        : selectedCoins.push(coin.item.value)
    "
  >
    <div
      v-if="isSelected"
      :class="[
        'absolute inset-0 bg-brand-gradient duration-300 ease-in-out opacity-0 group-hover:(opacity-5)',
      ]"
    />
    <div class="flex items-center gap-x-2.5">
      <span
        v-if="isSelected"
        class="i-ic:baseline-check bg-brand-gradient text-2xl"
      />
      <UseImage
        class="w-4 h-4"
        :src="`/icons/${coin.item.value.toLowerCase()}.svg`"
        :alt="coin.item.label"
      >
        <template #error>
          <div class="bg-white rounded-full w-4 h-4 opacity-20" />
        </template>
      </UseImage>
      <span class="font-bold">{{ coin.item.value }}</span>
    </div>
    <div
      :class="[
        'relative py-1.5 px-4 rounded-3 overflow-hidden duration-150 ease-in-out opacity-0 group-hover:(opacity-100)',
        // focusItemIndex === index && 'opacity-100'
      ]"
    >
      <div class="absolute inset-0 bg-brand-gradient opacity-5" />
      <span class="text-xs font-semibold text-brand-secondary">{{isSelected ? "Unselect" : "Select" }}</span>
    </div>
  </div>
</template>
